import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import TeamReportRegularAi from './team-report-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TeamReportRegularAi {...validProps} />;
}
SvgComponent.iconName = 'teamReportRegularAi';

export const TeamReportRegularAiIcon = svgIconWrapper(SvgComponent);
